'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$93() {
  this.bqq = null;
  this.bqr = false;
}
export { $c_Lpresto_PrestoRouter$$anon$93 as $c_Lpresto_PrestoRouter$$anon$93 };
$p = $c_Lpresto_PrestoRouter$$anon$93.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$93;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$93() {
}
export { $h_Lpresto_PrestoRouter$$anon$93 as $h_Lpresto_PrestoRouter$$anon$93 };
$h_Lpresto_PrestoRouter$$anon$93.prototype = $p;
$p.c1 = (function() {
  if ((!this.bqr)) {
    this.bqq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bqr = true;
  }
  return this.bqq;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$93 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$93, "presto.PrestoRouter$$anon$93", ({
  Pb: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$93 as $d_Lpresto_PrestoRouter$$anon$93 };
//# sourceMappingURL=presto.-Presto-Router$$anon$93.js.map
